module.exports = __webpack_public_path__ + "img/reson_2.afea90b0.png";